import React from 'react';

import GridComponent from './GridComponent';

export default ({ children, ...props }) => (
  <GridComponent primaryClassName="Grid-header" {...props}>
    {children}
  </GridComponent>
);



// WEBPACK FOOTER //
// ./src/components/basic/grid/GridHeader.js